<div class="layout-auto-1">
	<div class="" *ngIf="VCSyncfusionPdfViewer">
		<div class="grid grid-auto-1 app-pdfviewer-toolbar app-pdfviewer-toolbar-separator-bottom">
			<div class="spawn">
				<span [tooltip]="getRessource('tooltips.navigation.GoToFirstPage')"
				      flow="right">
					<i class="search-filter-action fa-duotone fa-chevrons-left"
					   [class.disabled]="VCSyncfusionPdfViewer.currentPageNumber === 1"
					   (click)="toolbar.navigation.pageChanged(1)">
					</i>
				</span>
				<span [tooltip]="getRessource('tooltips.navigation.PreviousPage')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-chevron-left"
					   [class.disabled]="VCSyncfusionPdfViewer.currentPageNumber === 1"
					   (click)="toolbar.navigation.previousClicked($event)">
					</i>
				</span>
				<div class="app-input-toolbar">
					<input [ngModel]="VCSyncfusionPdfViewer.currentPageNumber"
					       (ngModelChange)="toolbar.navigation.pageChanged($event)"
					       type="number"
					       class="" style="width: 48px; padding: 4px; margin: 4px;"/>
				</div>
				<span class="displayValue app-space-right">
					/ {{VCSyncfusionPdfViewer.pageCount}}
				</span>
				<span [tooltip]="getRessource('tooltips.navigation.NextPage')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-chevron-right"
					   [class.disabled]="VCSyncfusionPdfViewer.currentPageNumber === VCSyncfusionPdfViewer.pageCount"
					   (click)="toolbar.navigation.nextClicked($event)">
					</i>
				</span>
				<span [tooltip]="getRessource('tooltips.navigation.GoToLastPage')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-chevrons-right"
					   [class.disabled]="VCSyncfusionPdfViewer.currentPageNumber === VCSyncfusionPdfViewer.pageCount"
					   (click)="toolbar.navigation.pageChanged(VCSyncfusionPdfViewer.pageCount)">
					</i>
				</span>

			  <i class="app-pdfviewer-toolbar-separator-left"></i>

				<span [tooltip]="getRessource('tooltips.zoom.ZoomIn')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-magnifying-glass-plus "
				   [class.disabled]="toolbar.magnification.zoomIn"
				   (click)="toolbar.magnification.zoomInClicked($event)">
				</i>
				</span>
				<span [tooltip]="getRessource('tooltips.zoom.ZoomOut')"
				      flow="right">
				  <i class="search-filter-action fa-duotone fa-magnifying-glass-minus"
					   [class.disabled]="toolbar.magnification.zoomOut"
					   (click)="toolbar.magnification.zoomOutClicked($event)">
					</i>
				</span>
				<div class="app-input-toolbar"
				     *ngIf="VCSyncfusionPdfViewer.magnificationModule && VCSyncfusionPdfViewer.zoomPercentage">
					<input [ngModel]="VCSyncfusionPdfViewer.zoomPercentage"
					       (ngModelChange)="toolbar.magnification.zoomTo($event)"
					       type="number"
					       [tooltip]="getRessource('tooltips.')"
					       [defaultValue]="'100'" [disabled]="true"
					       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/> %
				</div>

				<span class="search-filter-action fa-stack"
							[tooltip]="getRessource('tooltips.zoom.FitPage')"
							flow="right"
				      style="margin-left: .25rem"
				      [class.disabled]="toolbar.magnification.fitPage"
				      (click)="toolbar.magnification.pageFitPageClicked($event)">
					<i class="fa-duotone fa-page fa-stack fa-stack-1x"></i>
					<i class="fa-solid fa-up-right-and-down-left-from-center fa-stack-1x fa-xs"></i>
				</span>
				<span class="search-filter-action fa-stack"
							[tooltip]="getRessource('tooltips.zoom.FitWidth')"
							flow="right"
				      style="margin-left: .25rem"
				      [class.disabled]="toolbar.magnification.fitWidth"
				      (click)="toolbar.magnification.pageFitWidthClicked($event)">
					<i class="fa-duotone fa-page fa-stack fa-stack-1x"></i>
					<i class="fa-solid fa-arrows-left-right fa-stack-1x fa-xs"></i>
				</span>
				<span class="search-filter-action fa-stack"
				      flow="right"
							[tooltip]="getRessource('tooltips.zoom.Automatic')"
				      [class.disabled]="toolbar.magnification.fitAuto"
				      (click)="toolbar.magnification.pageFitAutoClicked($event)">
					<i class="fa-duotone fa-magnifying-glass fa-stack fa-stack-1x"></i>
					<i class="fa-solid fa-circle-a fa-stack-1x fa-xs app-fa-pos-BottomLeft"></i>
				</span>
			</div>
			<div class="spawn-reverse">
				<ng-container *ngIf="toolbar.textSearch.searchVisible">
					<span class="app-disabled" *ngIf="toolbar.textSearch.matchCount > 0">
						({{toolbar.textSearch.matchPosition}} von {{toolbar.textSearch.matchCount}})
					</span>
					<span>
						<i class="search-filter-action fa-duotone fa-chevron-up"
						   flow="left"
						   [tooltip]="getRessource('tooltips.fileAction.searchPrevious')"
						   [class.disabled]="!toolbar.textSearch.canSearchPrevious"
						   (click)="toolbar.textSearch.searchPrevious()">
						</i>
						<i class="search-filter-action fa-duotone fa-chevron-down"
						   flow="left"
						   [tooltip]="getRessource('tooltips.fileAction.searchNext')"
						   [class.disabled]="!toolbar.textSearch.canSearchNext"
						   (click)="toolbar.textSearch.searchNext()">
						</i>
					</span>
					<div class="app-input-toolbar" style="margin-right: 4px;">
						<input [(ngModel)]="toolbar.textSearch.searchText"
						       (keydown.enter)="toolbar.textSearch.textSearch($event)"
						       (focusout)="toolbar.textSearch.textSearch($event)"
						       [placeholder]="getRessource('tooltips.fileAction.Searchtext')"
						       class="" style="width: 148px; padding: 2px 0; margin: 2px 0;"/>
						<i class="fa-duotone fa-xmark inEditor"
						   *ngIf="toolbar.textSearch.searchText.length > 0"
							 (click)="toolbar.textSearch.resetSearchText()">
						</i>
					</div>
				</ng-container>
				<span [tooltip]="getRessource('tooltips.fileAction.Findindocument')"
				      flow="left">
				  <i class="search-filter-action fa-duotone fa-magnifying-glass"
				   [class.fa-duotone]="!toolbar.textSearch.searchVisible"
				   [class.fa-solid]="toolbar.textSearch.searchVisible"
				   (click)="toolbar.menu.toggleTextSearch($event)">
				</i>
				</span>
				<span class="search-filter-action fa-stack"
							[tooltip]="getRessource('tooltips.fileAction.Annotation')"
							flow="left"
				      [class.disabled]="!canShowAnnotationToolbar"
				      (click)="toolbar.menu.toggleAnnotationToolbar()">
					<i class="fa-duotone fa-file-pen fa-stack fa-stack-1x">
					</i>
					<i class="fa-notes fa-stack-1x fa-xs app-fa-pos-BottomLeft"
					   [class.fa-solid]="toolbar.menu.showAnnotationToolbar"
					   [class.fa-light]="!toolbar.menu.showAnnotationToolbar">
					</i>
				</span>

				<span [tooltip]="getRessource('tooltips.fileAction.Download')"
				      flow="left">
				  <i class="search-filter-action fa-duotone fa-download"
					   (click)="toolbar.file.downloadClicked($event)">
					</i>
				</span>
			</div>
		</div>
		<div class="grid grid-auto-1 app-pdfviewer-toolbar app-pdfviewer-toolbar-separator-bottom"
		     *ngIf="toolbar.menu.showAnnotationToolbar">
			<div class="spawn">
				<ng-container *ngIf="!showOnlyStamps">
					<span [tooltip]="getRessource('tooltips.')">
					  <i class="search-filter-action fa-duotone fa-comment-captions"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'StickyNotes'"
					     (click)="viewer.annotation.setAnnotationMode('StickyNotes')"
					     *ngIf="viewer.annotation.buttons.comment">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.comment">
					</i>
					<span [tooltip]="getRessource('tooltips.annotation.text.Highlight')"
					      flow="right">
					  <i class="search-filter-action fa-duotone fa-highlighter-line"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Highlight'"
					     (click)="viewer.annotation.setAnnotationMode('Highlight')"
					     *ngIf="viewer.annotation.buttons.highlighter">
						</i>
					</span>
					<span [tooltip]="getRessource('tooltips.annotation.text.Underline')">
					  <i class="search-filter-action fa-duotone fa-underline"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Underline'"
					     (click)="viewer.annotation.setAnnotationMode('Underline')"
					     *ngIf="viewer.annotation.buttons.underline">
						</i>
					</span>
					<span [tooltip]="getRessource('tooltips.annotation.text.Strikethrough')">
					  <i class="search-filter-action fa-duotone fa-strikethrough"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Strikethrough'"
					     (click)="viewer.annotation.setAnnotationMode('Strikethrough')"
					     *ngIf="viewer.annotation.buttons.strikethrough">
						</i>
					</span>

				</ng-container>
				<ng-container *ngIf="showOnlyStamps">

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.menuStamps && !showOnlyStamps">
					</i>

					<span [tooltip]="getRessource('tooltips.annotation.stamps.checkmark')">
					  <i class="search-filter-action fa-duotone fa-check"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'customStamp'
															 && viewer.annotation.activeAnnotationMode.dynamicStampItem === 'check'"
					     (click)="viewer.annotation.setAnnotationMode('customStamp', 'check')"
					     *ngIf="viewer.annotation.buttons.xmark">
						</i>
					</span>

					<span [tooltip]="getRessource('tooltips.annotation.stamps.circle')">
					  <i class="search-filter-action fa-duotone fa-circle"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'customStamp'
															 && viewer.annotation.activeAnnotationMode.dynamicStampItem === 'circle'"
					     (click)="viewer.annotation.setAnnotationMode('customStamp', 'circle')"
					     *ngIf="viewer.annotation.buttons.circle">
						</i>
					</span>

					<span [tooltip]="getRessource('tooltips.annotation.stamps.crossmark')">
					  <i class="search-filter-action fa-duotone fa-x"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'customStamp'
															 && viewer.annotation.activeAnnotationMode.dynamicStampItem === 'cross'"
					     (click)="viewer.annotation.setAnnotationMode('customStamp', 'cross')"
					     *ngIf="viewer.annotation.buttons.xmark">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.showSubmenu.showStamps">
					</i>
				</ng-container>
				<ng-container *ngIf="!showOnlyStamps">

					<span [tooltip]="getRessource('tooltips.annotation.stamps.customStamp')">
					  <i class="search-filter-action fa-duotone fa-upload"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'customStamp'
															 && viewer.annotation.activeAnnotationMode.dynamicStampItem === 'uploadStamp'"
					     (click)="viewer.annotation.setAnnotationMode('customStamp', 'uploadStamp')"
					     *ngIf="viewer.annotation.buttons.uploadStamp
						          && viewer.annotation.showSubmenu.showStamps">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.menuForms">
					</i>
<!-- 					<span [tooltip]="getRessource('tooltips.annotation.menus.AddForm')"> -->
<!-- 					  <i class="search-filter-action fa-duotone fa-square-dashed-circle-plus" -->
<!-- 					     (click)="viewer.annotation.showSubmenu.showForms = !viewer.annotation.showSubmenu.showForms" -->
<!-- 					     *ngIf="viewer.annotation.buttons.menuForms"> -->
<!-- 						</i> -->
<!-- 					</span> -->

					<ng-container *ngIf="viewer.annotation.showSubmenu.showForms">
						<span [tooltip]="getRessource('tooltips.annotation.forms.Circle')">
							<i class="search-filter-action fa-duotone fa-circle"
							   [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Circle'"
							   (click)="viewer.annotation.setAnnotationMode('Circle')"
							   *ngIf="viewer.annotation.buttons.formCircle">
							</i>
						</span>
						<span [tooltip]="getRessource('tooltips.annotation.forms.Rectangle')">
							<i class="search-filter-action fa-duotone fa-square"
							   [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Rectangle'"
							   (click)="viewer.annotation.setAnnotationMode('Rectangle')"
							   *ngIf="viewer.annotation.buttons.formSquare">
							</i>
						</span>
						<span [tooltip]="getRessource('tooltips.annotation.forms.Polygon')">
							<!-- Icon isn't Center    -->
							<i class="search-filter-action fa-duotone fa-octagon"
							   style="padding-right: 1px;"
							   [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Polygon'"
							   (click)="viewer.annotation.setAnnotationMode('Polygon')"
							   *ngIf="viewer.annotation.buttons.formOctagon">
							</i>
						</span>
						<span [tooltip]="getRessource('tooltips.annotation.forms.Line')">
							<i class="search-filter-action fa-duotone fa-dash"
							   [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Line'"
							   (click)="viewer.annotation.setAnnotationMode('Line')"
							   *ngIf="viewer.annotation.buttons.formDash">
							</i>
						</span>
					</ng-container>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.freeText">
					</i>
					<span [tooltip]="getRessource('tooltips.annotation.text.AddTextbox')">
					  <i class="search-filter-action fa-duotone fa-input-text"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'FreeText'"
					     (click)="viewer.annotation.setAnnotationMode('FreeText')"
					     *ngIf="viewer.annotation.buttons.freeText">
						</i>
					</span>

					<i class="app-pdfviewer-toolbar-separator-left"
					   *ngIf="viewer.annotation.buttons.stamp">
					</i>
					<span [tooltip]="getRessource('tooltips.annotation.')">
					  <i class="search-filter-action fa-duotone fa-stamp"
					     *ngIf="viewer.annotation.buttons.stamp">
						</i>
					</span>
					<span>
					  <i class="app-pdfviewer-toolbar-separator-left"
					     *ngIf="viewer.annotation.buttons.drawing">
							</i>
					</span>
					<span [tooltip]="getRessource('tooltips.annotation.menus.DrawInk')">
					  <i class="search-filter-action fa-duotone fa-pen-swirl"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'Ink'"
					     (click)="viewer.annotation.setAnnotationMode('Ink')"
					     *ngIf="viewer.annotation.buttons.drawing">
							</i>
					</span>
					<span>
					  <i class="app-pdfviewer-toolbar-separator-left"
					     *ngIf="viewer.annotation.buttons.signature">
							</i>
					</span>
					<span [tooltip]="getRessource('tooltips.annotation.menus.Signature')">
					  <i class="search-filter-action fa-duotone fa-signature"
					     [class.active]="viewer.annotation.activeAnnotationMode.mode === 'HandWrittenSignature'"
					     (click)="viewer.annotation.setAnnotationMode('HandWrittenSignature')"
					     *ngIf="viewer.annotation.buttons.signature">
						</i>
					</span>
          <div *ngIf="excSecurity.isFeatured('DEVELOPMENT')">
            <span [tooltip]="'Stempel'" flow="right">
              <i class="search-filter-action fa-duotone fa-stamp"
                 (click)="toolbar.menu.toggleStempelMenu($event)"
                 *ngIf="viewer.annotation.buttons.signature">
              </i>
            </span>
          </div>
          <exg-popup #VCStempelMenu [closeAlways]="false">
            <div class="md-menu content" style="width: 300px; max-height: 400px; overflow-y: auto">
              <div class="md-menu-header" style="display: flex; align-items: center; gap: 8px">
                <span>{{getRessource('tooltips.annotation.userStempel.Header')}}</span>

                <exg-search-bar
                  [placeholder]="this.getRessource('tooltips.annotation.userStempel.emptySearch')"
                  (Search)="stempelFilter = $event"
                  style="flex: 1; border-bottom: none !important">
                </exg-search-bar>
              </div>
              <div *ngIf="userStempel.length === 0" class="md-menu-item">
                {{getRessource('tooltips.annotation.userStempel.Ghost')}}

              </div>
              <div *ngFor="let s of userStempelFiltered"
                   class="md-menu-item"
                   style="display: flex; align-items: center; gap: 8px"
                   (click)="applyStempel(s)">
                <img [src]="s.stpData" [alt]="s.stpName"
                     style="width:64px; height:64px; object-fit: contain;">
                <span class="typo-small"
                      style="overflow: hidden; text-overflow: ellipsis;">
                  {{ s.stpName }}
                </span>
              </div>
            </div>
          </exg-popup>
					<ng-container *ngIf="viewer.annotation.selectedAnnotationId.length > 0">
						<!-- TextEditors: TextColor; TextSize; Alignments; TextOptions -->
						<ng-container *ngIf="viewer.annotation.showSubmenu.showTextModifiers">
							<i class="app-pdfviewer-toolbar-separator-left">
							</i>
							<span [tooltip]="getRessource('tooltips.annotation.textProperties.Fontcolor')">
							<i class="search-filter-action fa-duotone fa-font"
							   style="margin-right: 1px"
							   [style.--fa-secondary-color]="viewer.annotation.selectedAnnotation?.fontColor !== '#ffffff00' ? viewer.annotation.selectedAnnotation?.fontColor : ''"
							   (click)="viewer.annotation.showSubmenu.showFontColor = !viewer.annotation.showSubmenu.showFontColor"
							   *ngIf="viewer.annotation.buttons.fontFamily">
							</i>
						</span>
							<div class="app-input-toolbar app-space-right_1"
							     *ngIf="viewer.annotation.showSubmenu.showFontColor">
								<input [ngModel]="viewer.annotation.selectedAnnotation?.fontColor"
								       (ngModelChange)="viewer.annotation.modify.fontColor($event)"
								       [tooltip]="getRessource('tooltips.annotation.textProperties.Fontcolor')"
								       type="color"
								       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
								<i class="fa-duotone fa-xmark afterEditor"
								   (click)="viewer.annotation.modify.fontColor('#ffffff00')">
								</i>
							</div>

							<!-- Text Größe -->
							<span [tooltip]="getRessource('tooltips.annotation.textProperties.Fontsize')">
								<i class="search-filter-action fa-font-case"
								   [class.fa-regular]="viewer.annotation.showSubmenu.showFontSize"
								   [class.fa-duotone]="!viewer.annotation.showSubmenu.showFontSize"
								   (click)="viewer.annotation.showSubmenu.showFontSize = !viewer.annotation.showSubmenu.showFontSize"
								   *ngIf="viewer.annotation.buttons.fontSize">
								</i>
							</span>
							<ng-container *ngIf="viewer.annotation.showSubmenu.showFontSize">

								<i class="search-filter-action fa-regular fa-plus"
								   (click)="viewer.annotation.modify.fontSize.increase()"
								   *ngIf="viewer.annotation.selectedAnnotation.fontSize">
								</i>
								<i class="search-filter-action fa-regular fa-minus"
								   style="margin-left: 2px"
								   (click)="viewer.annotation.modify.fontSize.decrease()"
								   *ngIf="viewer.annotation.selectedAnnotation.fontSize">
								</i>

								<div class="app-input-toolbar"
								     *ngIf="viewer.annotation.selectedAnnotation.fontSize">
									<input [ngModel]="viewer.annotation.selectedAnnotation.fontSize"
									       (ngModelChange)="viewer.annotation.modify.fontSize.setSize($event)"
									       type="number"
									       class="" style="width: 48px; padding: 4px; margin: 4px;"/>
								</div>
							</ng-container>

							<!-- Text Alignments -->
							<span [tooltip]="getRessource('tooltips.annotation.textProperties.TextAlign')">
								<i class="search-filter-action fa-regular"
								   (click)="viewer.annotation.showSubmenu.showTextAlignments = !viewer.annotation.showSubmenu.showTextAlignments"
								   [class.fa-align-left]="viewer.annotation.selectedAnnotation?.textAlign === 'Left'"
								   [class.fa-align-justify]="viewer.annotation.selectedAnnotation?.textAlign === 'Justify'"
								   [class.fa-align-right]="viewer.annotation.selectedAnnotation?.textAlign === 'Right'"
								   [class.fa-align-center]="viewer.annotation.selectedAnnotation?.textAlign === 'Center'"
								   *ngIf="viewer.annotation.buttons.menuAlign">
								</i>
							</span>
							<ng-container *ngIf="viewer.annotation.showSubmenu.showTextAlignments">
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Alignleft')">
									<i class="search-filter-action fa-duotone fa-align-left"
									   (click)="viewer.annotation.modify.fontAlignment('Left')"
									   *ngIf="viewer.annotation.buttons.fontAlignLeft
								          && viewer.annotation.selectedAnnotation.textAlign !== 'Left'">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Justify')">
									<i class="search-filter-action fa-duotone fa-align-justify"
									   (click)="viewer.annotation.modify.fontAlignment('Justify')"
									   *ngIf="viewer.annotation.buttons.fontAlignJustify
								          && viewer.annotation.selectedAnnotation.textAlign !== 'Justify'">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Alignright')">
									<i class="search-filter-action fa-duotone fa-align-right"
									   (click)="viewer.annotation.modify.fontAlignment('Right')"
									   *ngIf="viewer.annotation.buttons.fontAlignRight
								          && viewer.annotation.selectedAnnotation.textAlign !== 'Right'">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.textProperties.Center')">
									<i class="search-filter-action fa-duotone fa-align-center"
									   (click)="viewer.annotation.modify.fontAlignment('Center')"
									   *ngIf="viewer.annotation.buttons.fontAlignCenter
								          && viewer.annotation.selectedAnnotation.textAlign !== 'Center'">
									</i>
								</span>
							</ng-container>

							<!-- Text Options -->
							<ng-container *ngIf="viewer.annotation.selectedAnnotation?.fontStyle">
								<span [tooltip]="getRessource('tooltips.annotation.text.Bold')">
									<i class="search-filter-action fa-bold"
									   (click)="viewer.annotation.modify.fontStyle.changeBold()"
									   [class.fa-regular]="viewer.annotation.selectedAnnotation.fontStyle.isBold"
									   [class.fa-duotone]="!viewer.annotation.selectedAnnotation.fontStyle.isBold"
									   *ngIf="viewer.annotation.buttons.fontBold">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Underline')">
									<i class="search-filter-action fa-underline"
									   (click)="viewer.annotation.modify.fontStyle.changeUnderline()"
									   [class.fa-regular]="viewer.annotation.selectedAnnotation.fontStyle.isUnderline"
									   [class.fa-duotone]="!viewer.annotation.selectedAnnotation.fontStyle.isUnderline"
									   *ngIf="viewer.annotation.buttons.fontUnderline">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Strikethrough')">
									<i class="search-filter-action fa-strikethrough"
									   (click)="viewer.annotation.modify.fontStyle.changeStrikeout()"
									   [class.fa-regular]="viewer.annotation.selectedAnnotation.fontStyle.isStrikeout"
									   [class.fa-duotone]="!viewer.annotation.selectedAnnotation.fontStyle.isStrikeout"
									   *ngIf="viewer.annotation.buttons.fontStrikethrough">
									</i>
								</span>
								<span [tooltip]="getRessource('tooltips.annotation.text.Italic')">
									<i class="search-filter-action fa-italic"
									   (click)="viewer.annotation.modify.fontStyle.changeItalic()"
									   [class.fa-regular]="viewer.annotation.selectedAnnotation.fontStyle.isItalic"
									   [class.fa-duotone]="!viewer.annotation.selectedAnnotation.fontStyle.isItalic"
									   *ngIf="viewer.annotation.buttons.fontItalic">
									</i>
								</span>
							</ng-container>
						</ng-container>

						<!-- FormEditor: FillColor; LineColor; LineThickness; Opacity -->
						<i class="app-pdfviewer-toolbar-separator-left">
						</i>
						<ng-container *ngIf="viewer.annotation.showSubmenu.showModifiers">
							<span [tooltip]="getRessource('tooltips.annotation.properties.FillColor')">
								<i class="search-filter-action fa-duotone fa-fill-drip "
								   style="margin-right: 1px"
								   [style.--fa-secondary-color]="viewer.annotation.selectedAnnotation?.fillColor !== '#ffffff00' ? viewer.annotation.selectedAnnotation?.fillColor : ''"
								   (click)="viewer.annotation.showSubmenu.showFillColor = !viewer.annotation.showSubmenu.showFillColor"
								   *ngIf="viewer.annotation.buttons.fillColor">
								</i>
							</span>
							<div class="app-input-toolbar"
							     *ngIf="viewer.annotation.showSubmenu.showFillColor">
								<input [ngModel]="viewer.annotation.selectedAnnotation?.fillColor"
								       (ngModelChange)="viewer.annotation.modify.fillColor($event)"
								       [tooltip]="getRessource('tooltips.annotation.properties.FillColor')"
								       type="color"
								       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
								<i class="fa-duotone fa-xmark afterEditor"
								   (click)="viewer.annotation.modify.fillColor('#ffffff00')">
								</i>
							</div>

							<span [tooltip]="getRessource('tooltips.annotation.properties.Strokeedit')">
								<i class="search-filter-action fa-duotone fa-brush"
								   style="margin-right: 1px"
								   [style.--fa-secondary-color]="viewer.annotation.selectedAnnotation?.strokeColor !== '#ffffff00' ? viewer.annotation.selectedAnnotation?.strokeColor : ''"
								   (click)="viewer.annotation.showSubmenu.showStokeColor = !viewer.annotation.showSubmenu.showStokeColor"
								   *ngIf="viewer.annotation.buttons.lineColor">
								</i>
							</span>
							<div  class="app-input-toolbar"
							      *ngIf="viewer.annotation.showSubmenu.showStokeColor">
								<input [ngModel]="viewer.annotation.selectedAnnotation?.strokeColor"
								       [tooltip]="getRessource('tooltips.annotation.properties.Strokeedit')"
								       (ngModelChange)="viewer.annotation.modify.strokeColor($event)"
								       type="color"
								       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/>
								<i class="fa-duotone fa-xmark afterEditor"
								   (click)="viewer.annotation.modify.strokeColor('#ffffff00')">
								</i>
							</div>

							<span [tooltip]="getRessource('tooltips.annotation.properties.LineThickness')">
								<i class="search-filter-action fa-duotone fa-dash"
								   style="margin-right: 1px"
								   (click)="viewer.annotation.showSubmenu.showSliderThickness = !viewer.annotation.showSubmenu.showSliderThickness"
								   *ngIf="viewer.annotation.buttons.lineThickness">
								</i>
							</span>
							<div class="app-input-toolbar"
							     *ngIf="viewer.annotation.showSubmenu.showSliderThickness">
									<input [ngModel]="viewer.annotation.selectedAnnotation?.thickness"
									       [tooltip]="getRessource('tooltips.annotation.properties.LineThickness')"
									       (ngModelChange)="VCSyncfusionPdfViewer.annotationModule.modifyThickness($event)"
									       type="number" [step]=".1" [max]="100" [min]=".1"
									       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/> pt
								</div>
							</ng-container>

						<span [tooltip]="getRessource('tooltips.annotation.properties.Opacityedit')">
							<i class="search-filter-action fa-duotone fa-circle-half-stroke"
							   style="margin-right: 1px"
							   (click)="viewer.annotation.showSubmenu.showSliderOpacity = !viewer.annotation.showSubmenu.showSliderOpacity"
							   *ngIf="viewer.annotation.buttons.brightness">
							</i>
						</span>
						<div class="app-input-toolbar"
						     *ngIf="viewer.annotation.showSubmenu.showSliderOpacity">
							<input [ngModel]="viewer.annotation.selectedAnnotation?.opacity*100"
							       [tooltip]="getRessource('tooltips.annotation.properties.Opacityedit')"
							       (ngModelChange)="VCSyncfusionPdfViewer.annotationModule.modifyOpacity($event, true)"
							       type="number" [step]="1" [max]="100" [min]="0"
							       class="" style="width: 52px; padding: 2px 0; margin: 2px 0;"/> %
						</div>
					</ng-container>
				</ng-container>
			</div>
			<div class="spawn-reverse">
				<span [tooltip]="getRessource('tooltips.annotation.delete')">
				  <i class="search-filter-action fa-duotone fa-trash-can-xmark"
					   (click)="VCSyncfusionPdfViewer.annotationModule.deleteAnnotationById(viewer.annotation.selectedAnnotationId)"
					   *ngIf="viewer.annotation.buttons.annotationDelete && viewer.annotation.selectedAnnotationId.length > 0">
					</i>
				</span>
				<span [tooltip]="getRessource('tooltips.annotation.close')"
				      flow="left">
				  <i class="search-filter-action fa-regular fa-xmark"
					   (click)="toolbar.menu.toggleAnnotationToolbar()"
					   *ngIf="viewer.annotation.buttons.closeToolbar">
					</i>
				</span>
			</div>
		</div>
	</div>
	<div class="content" *ngIf="init && docID">
		<ejs-pdfviewer [id]="'pdfViewer_' + docID"

		               [serviceUrl]="service"
		               [documentPath]="docPath"
		               [dateTimeFormat]="'yyyy-MM-dd HH:mm:ss'"

		               [locale]="'de'"
		               style="height: 100%;"

		               [enableToolbar]="false"
		               [enableNavigationToolbar]="false"
		               [enableAnnotationToolbar]="false"
		               [enableFormDesignerToolbar]="false"
		               [enableCommentPanel]="false"

		               [enableAnnotation]="true"
		               [enableFormFields]="true"
		               [enableFormDesigner]="true"
		               [enableTextSearch]="true"
		               [enableTextSelection]="true"

		               [isSignatureEditable]="true"
		               [isExtractText]="true"

		               [annotationSettings]="viewerConfig.settings.AnnotationSettings"
		               [freeTextSettings]="viewerConfig.settings.freeTextSettings"
		               [stickyNotesSettings]="viewerConfig.settings.stickyNoteSettings"

		               [handWrittenSignatureSettings]="viewerConfig.settings.handWrittenSignatureSettings"

		               hyperlinkOpenState="NewTab"
		               (pageClick)="viewer.page.onClick($event)"
		               (hyperlinkClick)="viewer.hyperlinkClicked($event)"

		               (documentLoad)="viewer.file.documentLoaded($event)"
		               (documentLoadFailed)="viewer.reload()"

		               (downloadStart)="toolbar.file.downloadStart()"
		               (extractTextCompleted)="viewer.text.extractText($event)"

		               (textSelectionEnd)="viewer.selection.textSelected($event)"
		               (textSearchStart)="toolbar.textSearch.textSearchStart($event)"
		               (textSearchHighlight)="toolbar.textSearch.textSearchComplete($event)"

		               (annotationAdd)="viewer.annotation.annotationEventListener($event)"
		               (annotationSelect)="viewer.annotation.annotationEventListener($event)"
		               (annotationUnSelect)="viewer.annotation.annotationEventListener($event)"
		               (annotationRemove)="viewer.annotation.annotationEventListener($event)"
		               (annotationMove)="viewer.annotation.annotationEventListener($event)"
		               (annotationResize)="viewer.annotation.annotationEventListener($event)"
		               (annotationPropertiesChange)="viewer.annotation.annotationEventListener($event)"

		               (commentAdd)="viewer.annotation.commentEventListener($event)"
		               (commentEdit)="viewer.annotation.commentEventListener($event)"
		               (commentDelete)="viewer.annotation.commentEventListener($event)"
		               (commentSelect)="viewer.annotation.commentEventListener($event)"
		               (commentStatusChanged)="viewer.annotation.commentEventListener($event)"

									 (signatureSelect)="viewer.annotation.signatureSelect($event)"
									 (signatureUnselect)="viewer.annotation.signatureUnselect($event)"
		>
		</ejs-pdfviewer>
	</div>
	<input type="file" #fileUpload accept=".png,.jpeg" style="visibility: hidden">
	<div id="docID" style="visibility: hidden">{{docID}}</div>
</div>
